var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"18","viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 5.5H15M0 1.5H15M0 9.5H15M0 13.5H15","stroke":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }